import React, { useState } from 'react';
import { Table, ConfigProvider, theme, Dropdown, Avatar } from 'antd';
import {
    SlidersHorizontal, LayoutTemplate, Download, Settings,
    FileText, Trash2, ChevronDown, Plus
} from 'lucide-react';
import Layout from '../../Layout';
import { Link, useNavigate } from 'react-router-dom';

// ================= 1. DỮ LIỆU MẪU (MOCK DATA TỪ HÌNH) =================
const flatData = [
    { key: '1', name: 'Tivi [NTHQ]', code: 'BBTH_43', recallDate: '12/08/2026', createDate: '12/08/2026', creator: { name: 'H', color: '#a3e635' } },
    { key: '2', name: 'Ốc', code: 'BBTH_42', recallDate: '09/04/2026', createDate: '10/04/2026', creator: { name: '1', color: '#f97316' } },
    { key: '3', name: 'Dao mổ điện cao tần Plasma', code: 'BBTH_41', recallDate: '04/02/2026', createDate: '04/02/2026', creator: { name: '1', color: '#f97316' } },
    { key: '4', name: 'Iphone 6', code: 'BBTH_40', recallDate: '06/02/2026', createDate: '04/02/2026', creator: { name: '1', color: '#f97316' } },
    { key: '5', name: 'Máy tính', code: 'BBTH_39', recallDate: '28/12/2025', createDate: '29/12/2025', creator: { name: '1', color: '#f97316' } },
    { key: '6', name: 'fff', code: 'BBTH_38', recallDate: '21/11/2025', createDate: '21/11/2025', creator: { name: 'A', color: '#4ade80' } },
    { key: '7', name: 'Iphone 16', code: 'BBTH_34', recallDate: '13/11/2025', createDate: '14/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '8', name: 'Iphone 16', code: 'BBTH_33', recallDate: '13/11/2025', createDate: '14/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '9', name: 'Iphone 16', code: 'BBTH_32', recallDate: '14/11/2025', createDate: '14/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '10', name: '10tesst', code: 'BBTH_31', recallDate: '14/11/2025', createDate: '14/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '11', name: 'Đồng phục sản xuất', code: 'BBTH_29', recallDate: '12/11/2025', createDate: '13/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '12', name: 'Thu hồi cho anh Tân', code: 'BBTH_28', recallDate: '11/11/2025', createDate: '10/11/2025', creator: { name: '1', color: '#f97316' } },
    { key: '13', name: 'THIẾT BỊ A', code: 'BBTH_25', recallDate: '19/08/2025', createDate: '19/08/2025', creator: { name: '1', color: '#f97316' } },
];

const THEME_COLOR = '#3e91ab';

export default function RecallList() {
    const navigate = useNavigate();
    
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    // ================= 2. ĐỊNH NGHĨA CỘT =================
    const columns = [
        {
            title: 'Tên thu hồi',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-gray-700 dark:text-gray-200 font-medium">{text}</span>
        },
        { title: 'Mã thu hồi', dataIndex: 'code', key: 'code', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Ngày thu hồi', dataIndex: 'recallDate', key: 'recallDate', align: 'center', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Ngày tạo', dataIndex: 'createDate', key: 'createDate', align: 'center', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        {
            title: 'Người tạo',
            dataIndex: 'creator',
            key: 'creator',
            align: 'center',
            render: (creator) => {
                return (
                    <Avatar 
                        size={26} 
                        style={{ backgroundColor: creator.color }} 
                        className={`text-[11px] font-semibold text-white ${creator.name === '1' ? 'rounded-md rotate-12' : ''}`} // Styling nhẹ cho cái logo số 1 màu cam
                    >
                        {creator.name}
                    </Avatar>
                );
            }
        },
    ];

    // ================= 3. RENDER =================
    return (
        <Layout>
            <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-6 shrink-0 gap-4">
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Danh sách thu hồi</h1>
                </div>
                <button className="flex items-center gap-2 px-3 py-1.5 bg-[#3e91ab] text-white rounded text-sm font-medium hover:bg-[#357f96] transition-colors max-w-[120px]" onClick={() => navigate(`/assets/add-new-recall`)}>
                    <Plus size={16} /> Thêm mới
                </button>
            </div>
            
            <div className="bg-white dark:bg-gray-900 min-h-screen relative flex flex-col">

                {/* TOOLBAR - THAY ĐỔI ĐỘNG DỰA VÀO CHECKBOX */}
                <div className="flex flex-col border-b border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900">
                    
                    {/* KHỐI 1: HIỆN LÊN KHI CÓ CHECKBOX ĐƯỢC CHỌN (HÌNH 2) */}
                    {selectedRowKeys.length > 0 && (
                        <div className="flex items-center px-4 py-2 bg-blue-50/50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-700 animate-in fade-in duration-200 overflow-x-auto no-scrollbar">
                            <div className="flex items-center gap-4 md:gap-6 min-w-max">
                                <Dropdown menu={{ items: [{ key: '1', label: 'Biên bản thu hồi' }] }} trigger={['click']}>
                                    <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors whitespace-nowrap">
                                        <FileText size={16} className="mr-1.5 shrink-0" /> Biểu mẫu <ChevronDown size={14} className="ml-1 shrink-0" />
                                    </button>
                                </Dropdown>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-red-500 transition-colors whitespace-nowrap">
                                    <Trash2 size={16} className="mr-1.5 shrink-0" /> Xóa
                                </button>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors whitespace-nowrap">
                                    <Download size={16} className="mr-1.5 shrink-0" /> Export
                                </button>
                            </div>
                        </div>
                    )}

                    {/* KHỐI 2: TOOLBAR TIÊU CHUẨN */}
                    <div className="flex justify-between items-center px-4 py-3 overflow-x-auto no-scrollbar">
                        <div className="flex items-center gap-3 shrink-0 min-w-max">
                            <SlidersHorizontal size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                            <LayoutTemplate size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                            
                            <div className="w-px h-4 bg-gray-300 mx-1"></div>
                            
                            {/* Chữ thay đổi theo trạng thái chọn */}
                            {selectedRowKeys.length > 0 ? (
                                <span className="text-[13px] text-gray-600">
                                    Đã chọn <b className="text-gray-800">{selectedRowKeys.length}</b> bản ghi
                                </span>
                            ) : (
                                <span className="text-[13px] text-gray-500">
                                    Hiển thị 1 - {flatData.length} / {flatData.length} bản ghi
                                </span>
                            )}
                        </div>

                        {/* Các nút ẩn đi khi có dòng được chọn */}
                        {selectedRowKeys.length === 0 && (
                            <div className="flex items-center space-x-6 shrink-0 min-w-max ml-4 animate-in fade-in">
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors">
                                    <Download size={15} className="mr-1.5 text-gray-400" /> Export
                                </button>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors">
                                    <Settings size={15} className="mr-1.5 text-gray-400" /> Cài đặt
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* BẢNG DỮ LIỆU */}
                <div className="flex-1 overflow-hidden">
                    <ConfigProvider
                        theme={{
                            algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                            token: {
                                colorPrimary: THEME_COLOR, // Màu xanh cho Checkbox
                            },
                            components: {
                                Table: {
                                    headerBg: isDarkMode ? '#1f2937' : '#ffffff',
                                    headerColor: isDarkMode ? '#9ca3af' : '#6b7280',
                                    cellPaddingBlock: 12,
                                    rowHoverBg: isDarkMode ? '#374151' : '#f9fafb',
                                    borderColor: isDarkMode ? '#374151' : '#f3f4f6'
                                },
                            },
                        }}
                    >
                        <Table
                            rowSelection={{
                                selectedRowKeys,
                                onChange: setSelectedRowKeys,
                            }}
                            columns={columns}
                            dataSource={flatData}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                            rowClassName={(record) => selectedRowKeys.includes(record.key) ? 'bg-blue-50/20 cursor-pointer' : 'bg-transparent text-[13.5px] cursor-pointer'}
                            
                            // THÊM SỰ KIỆN onRow ĐỂ ĐIỀU HƯỚNG KHI NHẤN VÀO HÀNG
                            onRow={(record) => ({
                                onClick: () => {
                                    navigate('/assets/recall-detail');
                                    // Hoặc nếu bạn muốn truyền kèm ID hoặc mã bản ghi:
                                    // navigate(`/assets/recall-detail?id=${record.key}`);
                                },
                            })}
                        />
                    </ConfigProvider>
                </div>

                {/* CSS CUSTOM */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    /* Ẩn thanh cuộn cho mobile vuốt mượt */
                    .no-scrollbar::-webkit-scrollbar { display: none; }
                    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                    
                    /* Ẩn dấu kẻ dọc mặc định của Table Antd */
                    .ant-table-thead > tr > th::before {
                        display: none !important; 
                    }
                `}} />

            </div>
        </Layout>
    );
};